import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../../context/CartContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product);
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      className="group flex flex-col bg-white rounded-xl overflow-hidden border border-dark-100 shadow-card hover:shadow-card-hover hover:border-athletic-200 transition-all duration-300"
    >
      <div className="aspect-[4/3] bg-dark-50 relative overflow-hidden">
        <img src={product.image} alt={product.name} loading="lazy" className="w-full h-full object-contain p-6 group-hover:scale-105 transition-transform duration-500" />
        {product.badge && (
          <span className="absolute top-3 left-3 px-2.5 py-1 text-white text-[10px] font-bold uppercase tracking-wider rounded-md bg-athletic-600">{product.badge}</span>
        )}
        <span className="absolute bottom-3 right-3 px-3 py-1.5 bg-white/95 backdrop-blur rounded-lg text-dark-900 font-bold text-sm shadow-sm">${product.price.toFixed(2)}</span>
      </div>
      <div className="p-5 flex flex-col flex-grow">
        <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-athletic-600 mb-1.5">{product.categorySlug?.replace(/-/g, ' ')}</p>
        <h3 className="font-display text-lg font-semibold text-dark-900 mb-2 group-hover:text-athletic-600 transition-colors line-clamp-2 leading-snug">{product.name}</h3>
        <p className="text-sm text-dark-500 line-clamp-2 mb-4 flex-grow">{product.description}</p>
        <button onClick={handleAddToCart} className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-dark-900 text-white text-sm font-semibold hover:bg-athletic-600 transition-colors mt-auto">
          <ShoppingCart className="w-4 h-4" /> Add to Cart
        </button>
      </div>
    </Link>
  );
};

export default ProductCard;